import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=134de31a&scoped=true&"
import script from "./FormInput.vue?vue&type=script&lang=ts&"
export * from "./FormInput.vue?vue&type=script&lang=ts&"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=134de31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134de31a",
  null
  
)

export default component.exports